import { Injectable } from '@angular/core';
import {Http} from '@angular/http';
import 'rxjs/add/operator/map';

@Injectable()
export class DataService {

  constructor(public http:Http) { 
    console.log('Data Service Connected....');
  }

  getPosts(postType:string) {
   // alert('./assets/data/'+postType+'.json');
      return this.http.get('./assets/data/'+postType+'.json')
      .map(res=>res.json())
  }

 
}
 



// WEBPACK FOOTER //
// C:/Users/calvi/Documents/AngularProjects/calvinparksportfolio/src/app/services/data.service.ts